import {createContext} from 'react';

export const ToastContext = createContext({
    open(span: JSX.Element) {

    }
});